/**
 * 错误码常量与业务异常（附录B §1.3 / 附录C §2 令牌状态机）。
 */
export const ErrorCodes = {
  /** 令牌已过期 → 触发静默刷新 */
  TOKEN_EXPIRED: 'AUTH_401002',
  /** refresh 缺失/失效/已被轮换 → 清空状态跳登录，禁止重试循环 */
  REFRESH_INVALID: 'AUTH_401003',
  /** 刷新端点 CSRF 校验失败 → 跳登录并上报 traceId，不重试 */
  CSRF_FAILED: 'AUTH_403004',
} as const

export class BizError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly traceId?: string,
    readonly httpStatus?: number,
  ) {
    super(message)
    this.name = 'BizError'
  }
}

/**
 * 协议端点错误（RFC 6749 §5.2）：{@code /oauth2/token}、{@code /oauth2/revoke}、
 * {@code /userinfo} 返回的不是 {@code R<T>}，而是 {@code {error, error_description}}。
 *
 * <p>单独成类而不是塞进 {@link BizError}：业务码 {@code AUTH_*} 与 OAuth2 的
 * {@code invalid_grant} 是两套命名空间，混在一起就没法只凭类型判断"这是协议错误"。
 */
export class OAuth2Error extends Error {
  constructor(
    readonly error: string,
    readonly description?: string,
    readonly httpStatus?: number,
  ) {
    super(description ?? error)
    this.name = 'OAuth2Error'
  }
}
